export default __webpack_public_path__ + "static/media/angryIcon.bddf6c82.png";